export default "<app-question [dataPath] = \"'1.1'\"></app-question>"